import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CmpsIconModule, CmpsIconRegistry } from '@cmps/ng-uikit';
import { mdiChevronDown, mdiFolderHeartOutline } from '@mdi/js';

import { CmpsScorecardSubHeaderComponent } from './scorecard-sub-header.component';

@NgModule({
    declarations: [CmpsScorecardSubHeaderComponent],
    imports: [CmpsIconModule, CommonModule, FormsModule],
    exports: [CmpsScorecardSubHeaderComponent],
})
export class CmpsScorecardSubHeaderModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['folder-heart', mdiFolderHeartOutline],
            ['chevron-down', mdiChevronDown],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
